import { CotizacionVenta, CotizacionVentaDetalle } from '../services/cotizacionVentaService';
import { PedidoVenta, PedidoVentaDetalle } from '../services/pedidoVentaService';

/**
 * Transforma una CotizacionVenta a PedidoVenta para pre-cargar el formulario de pedido.
 * La única diferencia sustancial es nroTipoFormulario: "12" (pedido) en lugar de "10" (cotización).
 */
export const transformarCotizacionAPedido = (cotizacion: CotizacionVenta): PedidoVenta => {
  const detalles: PedidoVentaDetalle[] = (cotizacion.detalles || []).map((d: CotizacionVentaDetalle) => ({
    nroIdformulario: d.nroIdformulario,
    nroItem: d.nroItem,
    codigoArticulo: d.codigoArticulo,
    descripcionArticulo: d.descripcionArticulo,
    cantidad: d.cantidad,
    precioUnitario: d.precioUnitario ?? d.precioLista,
    descuento: d.descuento ?? d.porcDesc,
    porcDesc: d.porcDesc,
    subtotal: d.subtotal,
    notas: d.notas,
    um: d.um,
    codigoMoneda: d.codigoMoneda,
    cotizacion: d.cotizacion,
  }));

  return {
    ...cotizacion,
    nroTipoFormulario: '12',
    detalles,
  } as PedidoVenta;
};
